import { render, staticRenderFns } from "./TruyVanSMSForm.vue?vue&type=template&id=1bb2d6df&"
import script from "./TruyVanSMSForm.vue?vue&type=script&lang=js&"
export * from "./TruyVanSMSForm.vue?vue&type=script&lang=js&"
import style0 from "./TruyVanSMSForm.vue?vue&type=style&index=0&id=1bb2d6df&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports